import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
var _KYC_STATUS_DISPLAY_T;
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { Flex, Heading, Notice, Text } from '@applyboard/crystal-ui';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
export var KycStatusValues = /*#__PURE__*/function (KycStatusValues) {
  KycStatusValues["PASSED"] = "PASSED";
  KycStatusValues["REJECTED"] = "REJECTED";
  KycStatusValues["WARNING"] = "WARNING";
  KycStatusValues["INITIATED"] = "INITIATED";
  return KycStatusValues;
}({});
export var KYC_STATUS_DISPLAY_TEXT_INTENT = (_KYC_STATUS_DISPLAY_T = {}, _defineProperty(_KYC_STATUS_DISPLAY_T, KycStatusValues.PASSED, {
  text: 'Passed',
  intent: 'positive'
}), _defineProperty(_KYC_STATUS_DISPLAY_T, KycStatusValues.REJECTED, {
  text: 'Rejected',
  intent: 'negative'
}), _defineProperty(_KYC_STATUS_DISPLAY_T, KycStatusValues.WARNING, {
  text: 'Warning',
  intent: 'warning'
}), _defineProperty(_KYC_STATUS_DISPLAY_T, KycStatusValues.INITIATED, {
  text: 'Initiated',
  intent: 'primary'
}), _KYC_STATUS_DISPLAY_T);
export function KycStatusOverview(_ref) {
  var status = _ref.status,
    transactionId = _ref.transactionId,
    riskScore = _ref.riskScore,
    rpId = _ref.rpId,
    idAndIdentityVerification = _ref.idAndIdentityVerification;
  var _ref2 = status ? KYC_STATUS_DISPLAY_TEXT_INTENT[status] : KYC_STATUS_DISPLAY_TEXT_INTENT[KycStatusValues.INITIATED],
    statusText = _ref2.text,
    intent = _ref2.intent;
  return _jsxs(Notice, {
    width: "fill",
    intent: intent,
    children: [_jsx(Heading, {
      level: 2,
      intent: intent,
      children: statusText
    }), _jsxs(Flex, {
      gap: 8,
      children: [_jsxs(Flex, {
        direction: "column",
        gap: 4,
        children: [_jsx(Text, {
          children: "Transaction ID"
        }), _jsx(Text, {
          children: "RPID (=user reference on Jumio)"
        }), _jsx(Text, {
          children: "Risk Score"
        }), _jsx(Text, {
          children: "ID and Identity Verification"
        })]
      }), _jsxs(Flex, {
        direction: "column",
        gap: 4,
        children: [_jsx(Text, {
          children: transactionId
        }), _jsx(Text, {
          children: rpId
        }), _jsx(Text, {
          children: riskScore
        }), _jsx(Text, {
          children: idAndIdentityVerification
        })]
      })]
    })]
  });
}